import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Document } from '@contentful/rich-text-types'

import css from './styles.scss'

export interface TypePostEmbedCollapsingSectionFields {
  heading: string
  openOnLoad: boolean
  richTextContent: Document
}

interface EmbedCollapsingSectionProps {
  fields: TypePostEmbedCollapsingSectionFields
}

const EmbedCollapsingSection: React.FC<EmbedCollapsingSectionProps> = ({
  fields,
}: EmbedCollapsingSectionProps) => (
  <details className={css.EmbedCollapsingSection} open={fields.openOnLoad}>
    <summary>
      <h3>{fields.heading}</h3>
    </summary>

    {
      // The content is a full contentful rich text Document, so it is passed
      // through here to the contentful library to handle.
      // Note that this will only use default contentful renderers,
      // not any of the overrides we as options in <RichTextBody />
      documentToReactComponents(fields.richTextContent as Document)
    }
  </details>
)

export default EmbedCollapsingSection
